/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V2beta1Run } from './V2beta1Run';
import {
  V2beta1RunFromJSON,
  V2beta1RunFromJSONTyped,
  V2beta1RunToJSON,
  V2beta1RunToJSONTyped,
} from './V2beta1Run';

/**
 *
 * @export
 * @interface V2beta1ListRunsResponse
 */
export interface V2beta1ListRunsResponse {
  /**
   * List of retrieved runs.
   * @type {Array<V2beta1Run>}
   * @memberof V2beta1ListRunsResponse
   */
  runs?: Array<V2beta1Run>;
  /**
   * The total number of runs for the given query.
   * @type {number}
   * @memberof V2beta1ListRunsResponse
   */
  total_size?: number;
  /**
   * The token to list the next page of runs.
   * @type {string}
   * @memberof V2beta1ListRunsResponse
   */
  next_page_token?: string;
}

/**
 * Check if a given object implements the V2beta1ListRunsResponse interface.
 */
export function instanceOfV2beta1ListRunsResponse(value: object): value is V2beta1ListRunsResponse {
  return true;
}

export function V2beta1ListRunsResponseFromJSON(json: any): V2beta1ListRunsResponse {
  return V2beta1ListRunsResponseFromJSONTyped(json, false);
}

export function V2beta1ListRunsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1ListRunsResponse {
  if (json == null) {
    return json;
  }
  return {
    runs: json['runs'] == null ? undefined : (json['runs'] as Array<any>).map(V2beta1RunFromJSON),
    total_size: json['total_size'] == null ? undefined : json['total_size'],
    next_page_token: json['next_page_token'] == null ? undefined : json['next_page_token'],
  };
}

export function V2beta1ListRunsResponseToJSON(json: any): V2beta1ListRunsResponse {
  return V2beta1ListRunsResponseToJSONTyped(json, false);
}

export function V2beta1ListRunsResponseToJSONTyped(
  value?: V2beta1ListRunsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    runs: value['runs'] == null ? undefined : (value['runs'] as Array<any>).map(V2beta1RunToJSON),
    total_size: value['total_size'],
    next_page_token: value['next_page_token'],
  };
}
